export const FooterData = [
    {
        id:1,
        fheading : 'Company',
        item1:'About Us',
        item2: 'Blog',
        item3: 'Careers',
        item4 : 'Contact Us',
    },
    {
        id:2,
        fheading : 'Support',
        item1:'Help Center',
        item2: 'Safety Center',
        item3: 'Community Guidelines',
        
    },
    {
        id:3,
        fheading : 'Legal',
        item1:'Cookies Policy',
        item2: 'Privacy Policy',
        item3: 'Terms of Service',
        item4 : 'Law Enforcement',
    },
    {
        id:4,
        fheading : 'Install App',
        item5:'assets/footer/apple.png',
        item6: 'assets/footer/google.png',        
    }
]